import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const privacyContent = <>
      <p data-id="element-26">
        <strong data-id="element-27">Última actualización: Febrero 2024</strong>
      </p>
      <p data-id="element-28">
        En 3:00 AM Reset, respetamos su privacidad y nos comprometemos a
        proteger sus datos personales. Esta política describe cómo manejamos su
        información.
      </p>
      <h3 className="text-[#F5E6D0] font-sans font-bold mt-4" data-id="element-29">
        1. Recopilación de Información
      </h3>
      <p data-id="element-30">
        Solo recopilamos la información necesaria para procesar su compra y
        entregar el producto digital (nombre y correo electrónico). No
        almacenamos información de tarjetas de crédito; los pagos son procesados
        por proveedores seguros externos.
      </p>
      <h3 className="text-[#F5E6D0] font-sans font-bold mt-4" data-id="element-31">
        2. Uso de la Información
      </h3>
      <p data-id="element-32">
        Utilizamos su correo electrónico para enviarle el enlace de descarga del
        producto y, ocasionalmente, actualizaciones relevantes sobre el método.
        No vendemos ni compartimos sus datos con terceros para fines
        comerciales.
      </p>
      <h3 className="text-[#F5E6D0] font-sans font-bold mt-4" data-id="element-33">3. Cookies</h3>
      <p data-id="element-34">
        Utilizamos cookies esenciales para el funcionamiento del sitio y
        análisis anónimo de tráfico para mejorar la experiencia del usuario.
      </p>
      <h3 className="text-[#F5E6D0] font-sans font-bold mt-4" data-id="element-35">4. Derechos</h3>
      <p data-id="element-36">
        Usted tiene derecho a solicitar la eliminación de sus datos de nuestra
        lista de correo en cualquier momento haciendo clic en "darse de baja" en
        nuestros correos o contactándonos directamente.
      </p>
    </>;
  const termsContent = <>
      <p data-id="element-37">
        <strong data-id="element-38">Última actualización: Febrero 2024</strong>
      </p>
      <p data-id="element-39">
        Al adquirir el kit "3:00 AM Reset", usted acepta los siguientes términos
        y condiciones.
      </p>
      <h3 className="text-[#F5E6D0] font-sans font-bold mt-4" data-id="element-40">
        1. Uso Personal
      </h3>
      <p data-id="element-41">
        Este producto es para uso personal y exclusivo del comprador. Queda
        estrictamente prohibida su distribución, reventa, o compartir el archivo
        PDF o la tarjeta imprimible con terceros.
      </p>
      <h3 className="text-[#F5E6D0] font-sans font-bold mt-4" data-id="element-42">
        2. Propiedad Intelectual
      </h3>
      <p data-id="element-43">
        Todo el contenido, diseño, textos y metodología son propiedad
        intelectual de 3:00 AM Reset. La compra no transfiere los derechos de
        autor.
      </p>
      <h3 className="text-[#F5E6D0] font-sans font-bold mt-4" data-id="element-44">
        3. Descargo de Responsabilidad Médica
      </h3>
      <p data-id="element-45">
        Este producto es una guía de hábitos y gestión conductual.{' '}
        <strong data-id="element-46">No es un tratamiento médico ni psicológico.</strong>
        No sustituye el consejo de un profesional de la salud. Si sufre de
        insomnio crónico, depresión, ansiedad severa u otras condiciones,
        consulte a su médico antes de usar este método.
      </p>
      <h3 className="text-[#F5E6D0] font-sans font-bold mt-4" data-id="element-47">
        4. Política de Reembolso
      </h3>
      <p data-id="element-48">
        Debido a la naturaleza digital del producto (descarga inmediata), todas
        las ventas son finales. Sin embargo, si tiene problemas técnicos con la
        descarga, le asistiremos para resolverlos.
      </p>
    </>;
  return <footer className="w-full bg-[#0F1923] py-12 px-6 border-t border-[#B8A99A]/10" data-id="element-49">
      <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-50">
        <div className="text-[#B8A99A]/40 text-sm space-y-2" data-id="element-51">
          <p data-id="element-52">© 2024 3:00 AM Reset. Todos los derechos reservados.</p>
          <p data-id="element-53">Este producto no sustituye el consejo médico profesional.</p>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-sm" data-id="element-54">
          <button onClick={() => setActiveModal('privacy')} className="text-[#B8A99A] hover:text-[#E8614D] transition-colors underline decoration-[#B8A99A]/30 hover:decoration-[#E8614D]" data-id="element-55">
            Política de Privacidad
          </button>
          <button onClick={() => setActiveModal('terms')} className="text-[#B8A99A] hover:text-[#E8614D] transition-colors underline decoration-[#B8A99A]/30 hover:decoration-[#E8614D]" data-id="element-56">
            Términos y Condiciones
          </button>
        </div>
      </div>

      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" content={privacyContent} data-id="element-57" />

      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" content={termsContent} data-id="element-58" />
    </footer>;
}